'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    // Include base details
    processInclude(require('deborla/product/detail.js'));
    // Instore pickup
    processInclude(require('deborla/product/pdpInstoreInventory'));
    // Wishlists
    processInclude(require('wishlist/product/wishlist'));
    // Availability In Store
    processInclude(require('./storeLocator/storeLocator'));
    // Availability Mailing List
    processInclude(require('./product/availabilityMailingList'));
    // Carousels and Zoom
    processInclude(require('deborla/product/slickPDP'));
    // PDP "read more" description
    processInclude(require('./product/pdpDescription'));
});
